"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxVirtualizedCollectionStore = void 0;
var HxVirtualizedCollectionStore = /** @class */ (function () {
    function HxVirtualizedCollectionStore(nativeInterop) {
        this.collections = new Map();
        this.nativeInterop = nativeInterop;
    }
    HxVirtualizedCollectionStore.prototype.hasCollection = function (collectionId) {
        return this.collections.has(collectionId.getCompactIDString());
    };
    HxVirtualizedCollectionStore.prototype.findCollection = function (collectionId, sessionId) {
        if (collectionId) {
            var entry = this.collections.get(collectionId.getCompactIDString());
            if (entry !== undefined) {
                entry.sessionIds.add(sessionId);
                return entry.virtualizedCollection;
            }
        }
        return null;
    };
    HxVirtualizedCollectionStore.prototype.releaseCollection = function (collectionId, sessionId) {
        var entry = this.collections.get(collectionId);
        if (entry === undefined)
            return;
        var removed = entry.sessionIds.delete(sessionId);
        if (!removed) {
            throw new Error("Unexpected releaseCollection with no existing collection"); // Internal invariant violation
        }
        if (entry.sessionIds.size === 0) {
            if (entry.virtualizedCollection) {
                this.nativeInterop.deactivateObject(entry.virtualizedCollection.objectId, entry.virtualizedCollection.storageSequenceNumber);
            }
            this.collections.delete(collectionId);
        }
    };
    HxVirtualizedCollectionStore.prototype.addRefCollection = function (collectionCompactId, sessionId) {
        var entry = this.collections.get(collectionCompactId);
        if (entry !== undefined) {
            if (entry.sessionIds.has(sessionId)) {
                throw new Error("Unexpected call to addRefCollection of existing collection"); // Internal invariant violation
            }
            entry.sessionIds.add(sessionId);
        }
        else {
            this.collections.set(collectionCompactId, { virtualizedCollection: undefined, sessionIds: new Set([sessionId]) });
        }
    };
    // Return value indicates whether collection was properly loaded
    HxVirtualizedCollectionStore.prototype.onCollectionLoaded = function (collection) {
        var entry = this.collections.get(collection.objectId.getCompactIDString());
        if (entry) {
            entry.virtualizedCollection = collection;
            return true;
        }
        else {
            // The client might have released the collection instance
            this.nativeInterop.deactivateObject(collection.objectId, collection.storageSequenceNumber);
            return false;
        }
    };
    HxVirtualizedCollectionStore.prototype.onCollectionChanged = function (update) {
        var entry = this.collections.get(update.collectionId.getCompactIDString());
        if (entry !== undefined) {
            if (entry.virtualizedCollection) {
                entry.virtualizedCollection.applyVirtualizedCollectionUpdates(update);
                return Array.from(entry.sessionIds.keys());
            }
        }
        return [];
    };
    return HxVirtualizedCollectionStore;
}());
exports.HxVirtualizedCollectionStore = HxVirtualizedCollectionStore;
exports.default = HxVirtualizedCollectionStore;
